import { AxiosError, AxiosResponse } from "axios"
import AxiosInstance from "../components/Axios"
import { SubmittalProps } from "../interfaces/submittal_types"
import { API, APIResponse } from "@/components/_Shared/API/API"
import { CREATE_SUBMITTAL, UPDATE_SUBMITTAL, GET_SUBMITTAL_BY_ID, GET_SUBMITTALS_BY_PROJECT, GET_SUBMITTALS, GET_SUBMITTALS_BY_USER, MARK_SUBMITTAL_AS_COMPLETED, DELETE_SUBMITTAL } from "./Endpoints/submittals"

//**Argument must be a Submittal object
//**Returns the status code of the response
export async function createSubmittal(submittalData: SubmittalProps): Promise<AxiosResponse> {
    const response = await AxiosInstance.post<void>(CREATE_SUBMITTAL, submittalData)
    return response
}

export async function updateSubmittal(submittalData: SubmittalProps): Promise<AxiosResponse> {
    const encodedID = encodeURIComponent(submittalData.submittal_id ?? '')
    const response = await AxiosInstance.put<void>(UPDATE_SUBMITTAL.replace("{id}", encodedID), submittalData)
    return response
}   

export async function closeSubmittal(submittalId: string): Promise<Number> {
    try {
        const encodedID = encodeURIComponent(submittalId)
        const response = await AxiosInstance.put(`api/submittal/id/${encodedID}`, {
            is_active: false
        })
        return response.status
    } catch (error: unknown) {
        return 500
    }
}

export async function getSubmittalById(submittalId: string): Promise<APIResponse<SubmittalProps>> {
    const encodedID = encodeURIComponent(submittalId)
    const response = await API.get<SubmittalProps>(GET_SUBMITTAL_BY_ID.replace("{id}", encodedID))
    return response
}

export async function getSubmittalsByProjectId(projectId: string): Promise<SubmittalProps[]> {
    try {
        const encodedID = encodeURIComponent(projectId)
        const response = await AxiosInstance.get(GET_SUBMITTALS_BY_PROJECT.replace("{projectId}", encodedID))
        return response.data as SubmittalProps[]
    } catch (error: unknown) {
        if (error instanceof AxiosError) {
            throw error.response?.data
        } else if (error instanceof Error) {
            throw error.message
        }
        throw new Error("Unknown error")
    }
}

export async function getSubmittals(): Promise<SubmittalProps[]> {
    try {
        const response = await AxiosInstance.get(GET_SUBMITTALS)
        return response.data as SubmittalProps[]
    } catch (error: unknown) {
        if (error instanceof AxiosError) {
            throw error.response?.data
        } else if (error instanceof Error) {
            throw error.message
        }
        throw new Error("Unknown error")
    }
}

export async function getSubmittalByUser(email: string): Promise<SubmittalProps[]> {
    try {
        const response = await AxiosInstance.get(GET_SUBMITTALS_BY_USER.replace("{email}", email))
        return response.data as SubmittalProps[]
    } catch (error: unknown) {
        if (error instanceof AxiosError) {
            throw error.response?.data
        } else if (error instanceof Error) {
            throw error.message
        }
        throw new Error("Unknown error")
    }
}

export async function deleteSubmittal(submittalId: string): Promise<APIResponse> {
    const encodedID = encodeURIComponent(submittalId)
    const response = await API.delete<void>(DELETE_SUBMITTAL.replace("{id}", encodedID))
    return response
}

export async function markSubmittalAsCompleted(submittalId: string): Promise<APIResponse> {
    const encodedID = encodeURIComponent(submittalId)
    const response = await API.put<void>(MARK_SUBMITTAL_AS_COMPLETED.replace("{id}", encodedID))
    return response
}

